
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  DestroyRef,
  inject,
  input,
  InputSignal,
  model,
  ModelSignal,
  OnInit,
  output,
  OutputEmitterRef,
  Signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';
import { QuantityCounterInputModel } from '@libs/form/models';
import { ProductModel, ShoppingListItemModel } from '@libs/shop/models';
import { debounceTime } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { ProductBundleListCardComponent, ProductLineItemComponent } from '../../../catalog';

@Component({
  selector: 'ui-shopping-list-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ProductBundleListCardComponent,
    ProductLineItemComponent,
  ],
  templateUrl: './shopping-list-item.component.html',
  styleUrl: './shopping-list-item.component.scss',
})
export class ShoppingListItemComponent implements OnInit {
  public product: InputSignal<ProductModel> = input.required();
  public shoppingListItem: InputSignal<ShoppingListItemModel> = input.required();
  public readonly: InputSignal<boolean> = input(false);
  public selected: ModelSignal<boolean> = model(false);
  public showCheckbox: InputSignal<boolean> = input(false);

  public quantityChanged: OutputEmitterRef<ShoppingListItemModel> = output();
  public removed: OutputEmitterRef<ShoppingListItemModel> = output();

  public quantityCounterControl: FormControl<number> = new FormControl(0, { updateOn: 'blur' }) as FormControl<number>;
  public quantityCounterDefaultData: QuantityCounterInputModel = {
    type: 'quantityCounter',
    label: '',
    name: 'quantity',
    attributes: {
      min: '1',
    },
  };

  public quantityCounterData: Signal<QuantityCounterInputModel> = computed(() => ({
    ...this.quantityCounterDefaultData,
    value: this.shoppingListItem().quantity,
    attributes: {
      min: '1',
    },
  }));

  private readonly destroyRef: DestroyRef = inject(DestroyRef);

  public ngOnInit(): void {
    this.quantityCounterControl.setValue(this.shoppingListItem().quantity);
    this.quantityCounterControl.valueChanges.pipe(debounceTime(500), distinctUntilChanged(), takeUntilDestroyed(this.destroyRef)).subscribe((value: number) => {
      if (this.shoppingListItem().quantity === value) {
        return;
      }

      this.quantityChanged.emit({
        ...this.shoppingListItem(),
        quantity: value,
      });
    });
  }

  public onRemoveShoppingListItem(): void {
    this.removed.emit(this.shoppingListItem());
  }
}
